import {useEffect, useState} from "react";
import axios from "axios";
import {buyeeUrl} from "utils/url";

const PopularCategories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios
      .get('files/cobrand/demogra_categories.json')
      .then(response => {
        setCategories(response.data);
      });
  }, []);

  const sendGaEvent = index => {
    if (window.ga) {
      const eventFlag = `tw_top_category_nolog_def_0${index + 1}`;
      window.ga("gtm1.send", "event", eventFlag, "click", eventFlag);
    }
  };

  return (
    <>
      {categories.length > 0 &&
        <section className="tw-about__list clearfix">
          <h3 className="title__product-list">人気分類</h3>
          <div className="demogra-list">
            <div className="demogra-list__outer">
              <ul className="product-list demogra-list">
                {categories.map((category, i) =>
                  <li className="item" key={i}>
                    <a onClick={() => sendGaEvent(i)}
                      href={buyeeUrl(`item/search/category/${category.categoryId}?lang=cht&conversionType=tw_top_demogra_list_61&rc=twy_cobrand_entry&twTran=1`)}
                      target="_blank">
                      <div className="demogra-list__media">
                        <img className="demogra-list__img" src={category.imageUrl}/>
                      </div>
                      <h4 className="demogra-list__categoryLabel">
                        <span className="categoryLabel__upper">{category.upperName}</span>
                        {category.name}
                      </h4>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </section>
      }
    </>
  );
};

export default PopularCategories;
